import { takeLatest, call, put } from 'redux-saga/effects';
import {
  getUserListSuccess,
  getUserListFailure,
} from './global.actions';
import { GET_USER_LIST_REQUEST } from './global.constants';
import { getUserListApi } from './global.api';


export function* getUserListSaga() {
  try {
    const res = yield call(getUserListApi);
    yield put(getUserListSuccess(res.data));
  } catch (error) {
    yield put(getUserListFailure(error));
  }
}


export default function* boardSaga() {
  yield takeLatest(GET_USER_LIST_REQUEST, getUserListSaga);
}
